export function resolveItemKey(item, itemKeyField) {
  if (typeof item === 'object' && item !== null && itemKeyField in item) {
    return String(item[itemKeyField]);
  }
  return '';
}